<template>
	<div>
        <bread-nav :assessment-cycle="assessmentCycle"
                 :facility-name="facilityName"
                 :classroom-name="classroomName"
                 :cycle-stage="cycleStage"
        ></bread-nav>

		<assessment-cycle-version-banner
			:assessment-cycle="assessmentCycle"
		></assessment-cycle-version-banner>
			
        <div class="row">
        	<div class="col-md-12">
			    <form action="" method="POST">
			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="classroom_name" class="col-md-4 text-right">Classroom/Area</label>
			                    <div class="col-sm-6">
			                        {{ classroomName }}
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="initial_assessment_date" class="col-md-4 col-form-label text-right">
			                        Initial Assessment Date
			                        <span style="color:red; font-size:1.2em;">*</span>
			                    </label>
			                    <div class="col-md-4">
			                        <input 
			                        	type="date" 
			                        	class="form-control" 
			                        	id="initial_assessment_date" 
			                        	name="initial_assessment_date" 
			                        	:min="parseStartDate()"
			                        	:max="parseEndDate()"
			                        	:value="formatDate(generalInfo.initial_assessment_date)"
			                        	:disabled="generalInfo.locked_at || cycle.completed_at"
			                        	@change="updateGeneralInfo($event)"
			                        >
			                        <div v-if="generalInfoErrors.initial_assessment_date">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.initial_assessment_date }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
					</div><!-- .row -->

					<div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="followup_assessment_date" class="col-md-4 col-form-label text-right">
			                        Followup Assessment Date
			                        <span style="color:red; font-size:1.2em;">*</span>
			                    </label>
			                    <div class="col-md-4">
			                        <input 
			                        	type="date" 
			                        	class="form-control" 
			                        	id="followup_assessment_date" 
			                        	name="followup_assessment_date" 
			                        	:disabled="generalInfo.locked_at || cycle.completed_at"
			                        	:value="formatDate(generalInfo.followup_assessment_date)"
			                        	@change="updateGeneralInfo($event)"
			                        >
			                        <div v-if="generalInfoErrors.followup_assessment_date">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.followup_assessment_date }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
					</div><!-- .row -->

					<div class="row">
			        	<div class="col">
			                <div class="form-group row">
			                    <label for="additional_date_info" class="col-md-4 col-form-label text-right">Additional Date Information</label>
			                    <div class="col-md-7">
			                        <textarea 
				                        class="form-control" 
				                        id="additional_date_info" 
				                        name="additional_date_info" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        placeholder="Hours, time of day observed, etc" 
				                        :value="generalInfo.additional_date_info"
				                        @change="updateGeneralInfo($event)"
				                    ></textarea>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="number_staff_receiving_technical_assistance" class="col-md-4 col-form-label text-right">
			                        Number of Staff Receiving Technical Assistance<span style="color:red; font-size:1.2em;">*</span>
			                    </label>
			                    <div class="col-md-4">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="number_staff_receiving_technical_assistance" 
				                        name="number_staff_receiving_technical_assistance" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.number_staff_receiving_technical_assistance"
				                        @change="updateGeneralInfo($event)"
			                        >
			                        <div v-if="generalInfoErrors.number_staff_receiving_technical_assistance">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.number_staff_receiving_technical_assistance }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="youngest_age" class="col-md-4 col-form-label text-right">Youngest Age in Classroom<span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-1">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="youngest_age_years" 
				                        name="youngest_age_years" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.youngest_age_years"
				                        @change="updateGeneralInfo($event)"
				                    >
			                    </div>
			                    <div class="col-md-1 col-form-label">
			                        year(s)
			                    </div>
			                    <div class="col-md-1">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="youngest_age_months" 
				                        name="youngest_age_months" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.youngest_age_months"
				                        @change="updateGeneralInfo($event)"
			                        >
			                    </div>
			                    <div class="col-md-1 col-form-label">
			                        month(s)
			                    </div>
			                    <div v-if="generalInfoErrors.youngest_age_years || generalInfoErrors.youngest_age_months" class="col-md-8 offset-md-4">
			                		<span class="invalid-feedback d-block" role="alert">
								        <b>{{ generalInfoErrors.youngest_age_years }} {{ generalInfoErrors.youngest_age_months }}</b>
								    </span>
			                	</div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="oldest_age" class="col-md-4 col-form-label text-right">Oldest Age in Classroom<span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-1">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="oldest_age_years" 
				                        name="oldest_age_years" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.oldest_age_years"
				                        @change="updateGeneralInfo($event)"
				                    >
			                    </div>
			                    <div class="col-md-1 col-form-label">
			                        year(s)
			                    </div>
			                    <div class="col-md-1">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="oldest_age_months" 
				                        name="oldest_age_months"
				                        :disabled="generalInfo.locked_at || cycle.completed_at" 
				                        :value="generalInfo.oldest_age_months"
				                        @change="updateGeneralInfo($event)"
			                        >
			                    </div>
			                    <div class="col-md-1 col-form-label">
			                        month(s)
			                    </div>
			                    <div v-if="generalInfoErrors.oldest_age_years || generalInfoErrors.oldest_age_months" class="col-md-8 offset-md-4">
			                    	<span class="invalid-feedback d-block" role="alert">
								        <b>{{ generalInfoErrors.oldest_age_years }} {{ generalInfoErrors.oldest_age_months }}</b>
								    </span>
			                    </div>
			                </div><!-- .form-group -->	                
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="number_children_initial" class="col-md-4 col-form-label text-right">Number of children enrolled at initial assessment<span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-4">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="number_children_initial" 
				                        name="number_children_initial" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.number_children_initial"
				                        @change="updateGeneralInfo($event)"
				                    >
				                    <div v-if="generalInfoErrors.number_children_initial">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.number_children_initial }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="number_children_followup" class="col-md-4 col-form-label text-right">Number of children enrolled at followup assessment<span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-4">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="number_children_followup" 
				                        name="number_children_followup" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.number_children_followup"
				                        @change="updateGeneralInfo($event)"
				                    >
				                    <div v-if="generalInfoErrors.number_children_followup">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.number_children_followup }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="number_children_special_health_care_needs" class="col-md-4 col-form-label text-right">Total Number of Children with Special Health Care Needs<span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-4">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="number_children_special_health_care_needs" 
				                        name="number_children_special_health_care_needs"
				                        :disabled="generalInfo.locked_at || cycle.completed_at" 
				                        :value="generalInfo.number_children_special_health_care_needs"
				                        @change="updateGeneralInfo($event)"
			                        >
			                        <div v-if="generalInfoErrors.number_children_special_health_care_needs">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.number_children_special_health_care_needs }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

					<div class="row">
			        	<div class="col">
			                <div class="form-group row">
			                    <label for="special_health_care_needs" class="col-md-4 col-form-label text-right">Number of Special Health Care Needs</label>
			                    <div class="col-md-2">
			                    	<div class="row mb-2">
			                    		<div class="col-md-6">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_allergies" 
						                        name="number_allergies"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_allergies"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-6 col-form-label">
					                        Allergies
					                    </div>
			                    	</div>
			                    	<div class="row mb-2">
			                    		<div class="col-md-6">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_asthma" 
						                        name="number_asthma"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_asthma"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-6 col-form-label">
					                        Asthma
					                    </div>
			                    	</div>
			                    	<div class="row">
			                    		<div class="col-md-6">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_diabetes" 
						                        name="number_diabetes"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_diabetes"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-6 col-form-label">
					                        Diabetes
					                    </div>
			                    	</div>
								</div> <!-- .col -->
								<div class="col-md-4">
			                    	<div class="row mb-2">
			                    		<div class="col-md-3">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_seizures" 
						                        name="number_seizures"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_seizures"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-7 col-form-label">
					                        Seizures
					                    </div>
			                    	</div>
			                    	<div class="row mb-2">
			                    		<div class="col-md-3">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_developmental_delays" 
						                        name="number_developmental_delays"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_developmental_delays"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-7 col-form-label">
					                        Developmental Delays
					                    </div>
			                    	</div>
			                    	<div class="row">
			                    		<div class="col-md-3">
					                        <input 
						                        type="number" 
						                        class="form-control" 
						                        id="number_social_emotional_needs" 
						                        name="number_social_emotional_needs"
						                        :disabled="generalInfo.locked_at || cycle.completed_at" 
						                        :value="generalInfo.number_social_emotional_needs"
						                        @change="updateGeneralInfo($event)"
					                        >
					                    </div>
					                    <div class="col-md-7 col-form-label">
					                        Social/Emotional Needs
					                    </div>
			                    	</div>
								</div> <!-- .col -->
								<div v-if="numberSpecialHealthCareError" class="col-md-8 offset-md-4">
		                        	<span class="invalid-feedback d-block" role="alert">
								        <b>Values must be positive numbers</b>
								    </span>
		                        </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			        	<div class="col">
			                <div class="form-group row">
			                    <label for="health_care_comments" class="col-md-4 col-form-label text-right">Health Care Comments</label>
			                    <div class="col-md-7">
			                        <textarea
				                        class="form-control" 
				                        id="health_care_comments" 
				                        name="health_care_comments" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.health_care_comments"
				                        placeholder="Other conditions and/or details, no personally identifiable information" 
				                        @change="updateGeneralInfo($event)"
			                        ></textarea>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="number_children_medication_needs" class="col-md-4 col-form-label text-right">Total Number of Children with Medication Needs <span style="color:red; font-size:1.2em;">*</span></label>
			                    <div class="col-md-4">
			                        <input 
				                        type="number" 
				                        class="form-control" 
				                        id="number_children_medication_needs" 
				                        name="number_children_medication_needs" 
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        :value="generalInfo.number_children_medication_needs"
				                        @change="updateGeneralInfo($event)"
			                        >
			                        <div v-if="generalInfoErrors.number_children_medication_needs">
			                        	<span class="invalid-feedback d-block" role="alert">
									        <b>{{ generalInfoErrors.number_children_medication_needs }}</b>
									    </span>
			                        </div>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="row">
			        	<div class="col">
			        		<div class="row">
			        			<div class="col-md-4 text-right">
			        				<a :href="'https://ncchildcaresearch.dhhs.state.nc.us/Main_info.asp?Facility_ID='+ facilityLicense" target="_blank">ncchildcaresearch.dhhs.state.nc.us</a>
			        			</div>
			        		</div>
			                <div class="form-group row">
			                    <label for="sanitation_inspection_date" class="col-md-4 col-form-label text-right">
			                        Most Recent Facility Sanitation Inspection
			                    </label>
			                    <div class="col-md-4">
			                        <input 
			                        	type="date" 
			                        	class="form-control" 
			                        	id="sanitation_inspection_date" 
			                        	name="sanitation_inspection_date" 
			                        	:disabled="generalInfo.locked_at || cycle.completed_at"
			                        	:value="formatDate(generalInfo.sanitation_inspection_date)"
			                        	@change="updateGeneralInfo($event)"
			                        >
			                    </div>
			                </div> <!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

		        	<div class="row">
			            <div class="col">
			                <div class="form-group row">
			                    <label for="sanitation_classification" class="col-md-4 col-form-label text-right">
			                        Facility Sanitation Classification
			                    </label>
			                    <div class="col-md-4">
			                        <select 
				                        class="form-control" 
				                        id="sanitation_classification" 
				                        name="sanitation_classification"
				                        :disabled="generalInfo.locked_at || cycle.completed_at"
				                        @change="updateGeneralInfo($event)"
			                        >
			                            <option value>Select ...</option>
			                            <option 
			                            	value="Superior"
			                            	:selected="generalInfo.sanitation_classification === 'Superior'"
			                            >
				                        	Superior
				                        </option>
			                            <option 
			                            	value="Approved"
			                            	:selected="generalInfo.sanitation_classification === 'Approved'"
			                            	@change="updateGeneralInfo($event)"
			                            >
				                        	Approved
				                        </option>
			                            <option 
			                            	value="Provisional"
			                            	:selected="generalInfo.sanitation_classification === 'Provisional'"
			                            	@change="updateGeneralInfo($event)"
			                            >
				                        	Provisional
				                        </option>
			                            <option 
			                            	value="Disapproved"
			                            	:selected="generalInfo.sanitation_classification === 'Disapproved'"
			                            	@change="updateGeneralInfo($event)"
			                            >
				                        	Disapproved
				                        </option>
			                        </select>
			                    </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

		            <div class="row">
		            	<div class="col">
		            		<div class="form-group row">
				                <label for="administrative_action" class="col-md-4 col-form-label text-right">
				                    Administrative action in last 3 years?
				                </label>
				                <div class="col-md-4">
				                    <div class="form-check form-check-inline">
				                        <input 
					                        class="form-check-input" 
					                        type="radio" 
					                        name="administrative_action" 
					                        id="administrative_action_yes" 
					                        value="1"
					                        :disabled="generalInfo.locked_at || cycle.completed_at"
					                        :checked="generalInfo.administrative_action === 1"
					                        @change="updateGeneralInfoRadio($event)"
				                        >
				                        <label class="form-check-label" for="administrative_action_yes">Yes</label>
				                    </div>
				                    <div class="form-check form-check-inline mt-1">
				                        <input 
					                        class="form-check-input" 
					                        type="radio" 
					                        name="administrative_action" 
					                        id="administrative_action_no" 
					                        value="0"
					                        :disabled="generalInfo.locked_at || cycle.completed_at"
					                        :checked="generalInfo.administrative_action === 0"
					                        @change="updateGeneralInfoRadio($event)"
				                        >
				                        <label class="form-check-label" for="administrative_action_no">No</label>
				                    </div>
				                </div>
			                </div><!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->
			        <div class="row">
			        	<div class="col">			  
			                <div class="form-group row">
			                    <label for="administrative_action_date" class="col-md-4 col-form-label text-right">
			                        As of
			                    </label>
			                    <div class="col-md-4">
			                        <input 
			                        	type="date" 
			                        	class="form-control" 
			                        	id="administrative_action_date" 
			                        	name="administrative_action_date" 
			                        	:disabled="generalInfo.locked_at || cycle.completed_at"
			                        	:value="formatDate(generalInfo.administrative_action_date)"
			                        	@change="updateGeneralInfo($event)"
			                        >
			                    </div>
			                </div> <!-- .form-group -->
			            </div><!-- .col -->
			        </div><!-- .row -->

			        <div class="form-group row mb-0">
			        	<div class="col-md-8 offset-md-3">
		                    <ul>
		                        <li>Data are saved automatically as you input them</li>
		                        <li><span style="color:red;">* required to lock</span></li>
		                    </ul>
		                </div>
		                <div class="col-md-8 offset-md-3">
				            <button 
				            	v-if="!generalInfo.locked_at && !cycle.completed_at"
				            	id="general_info_lock_button"
					            type="submit" 
					            class="btn btn-primary ml-3"
					            @click.prevent="lockGeneralInfo()"
					        >
					        	&nbsp; Lock &nbsp;
					        </button>
					        <button 
				            	v-if="generalInfo.locked_at && !cycle.completed_at"
				            	id="general_info_unlock_button"
					            type="submit" 
					            class="btn btn-primary ml-3"
					            @click.prevent="unlockGeneralInfo()"
					        >
					        	&nbsp; Unlock &nbsp;
					        </button>
				            <a :href="'/facilities/'+ cycle.facility_id" class="btn btn-secondary ml-4">Back to Facility Detail</a>
				        </div>
				    </div>
			    </form>
			</div>
	    </div>
	</div>
</template>

<script>
	import BreadNav from '../breadcrumb_navbar/BreadNav'
	import AssessmentCycleVersionBanner from './AssessmentCycleVersionBanner.vue'
    import { mapState } from 'vuex'
    import moment from 'moment'

    export default {
        name: "General Info",

        components: { 
			BreadNav,
			AssessmentCycleVersionBanner
		 },

        props: {
            assessmentCycle: Object,
			assessmentCycleVersions: Object,
            facilityName: String,
            classroomName: String
        },

        data() {
        	return {
        		cycleStage: this.$options.name 
        	}     
         },

        methods: {
        	updateGeneralInfo (e) {
        		let data = {
        			assessment_cycle_id: this.cycle.id,
                    [e.target.id]: e.target.value
                }

                if (e.target.name == 'initial_assessment_date' && isNaN(Date.parse(e.target.value))) {
                    return
                }

                const startDate = this.parseStartDate()
                const endDate = this.parseEndDate()

                if (e.target.name == 'initial_assessment_date' && e.target.value < startDate) {
                    this.generalInfoErrors.initial_assessment_date = 'Must be on/after '+ startDate;
                    return
                }
                if (e.target.name == 'initial_assessment_date' && e.target.value > endDate) {
                    this.generalInfoErrors.initial_assessment_date = 'Must be on/before '+ endDate;
                    return
                }
               
                this.$store.dispatch('general_info/saveGeneralInfo', data)
        		this.$store.dispatch('general_info/setGeneralInfoElement', {id: e.target.id, value: e.target.value})
            },
            updateGeneralInfoRadio (e) {
            	let data = {
        			assessment_cycle_id: this.cycle.id
                }

            	if (e.target.id == "administrative_action_yes") {
            		data.administrative_action = 1
            		this.$store.dispatch('general_info/setGeneralInfoElement', {id: "administrative_action", value: 1})
            	} else {
            		data.administrative_action = 0
            		this.$store.dispatch('general_info/setGeneralInfoElement', {id: "administrative_action", value: 0})
            	}
				
				if(e.target.name == 'assessment_cycle_version_id') {
					data.assessment_cycle_version_id = e.target.value
				}

            	this.$store.dispatch('general_info/saveGeneralInfo', data)
            },
            lockGeneralInfo () {
            	let data = [
                    {id: 'assessment_cycle_id', value: this.cycle.id}
                ]

            	this.$store.dispatch('general_info/lockGeneralInfo', data)
            },
            unlockGeneralInfo () {
            	let data = [
                    {id: 'assessment_cycle_id', value: this.cycle.id}
                ]

            	this.$store.dispatch('general_info/unlockGeneralInfo', data)
            },
            formatDate (date) {
                return date ? moment(date).format('YYYY-MM-DD') : null
            },
            parseStartDate () {
            	return this.cycle.version ? moment(this.cycle.version.start_date).format('YYYY-MM-DD') : ''
            },
            parseEndDate () {
            	return this.cycle.version ? moment(this.cycle.version.end_date).format('YYYY-MM-DD') : ''
            } 
        },

        computed: {
            ...mapState({
                cycle: state => state.cycle.cycle,
                facilityLicense: state => state.general_info.facilityLicense,
                generalInfo: state => state.general_info.generalInfo,
                generalInfoErrors: state => state.general_info.generalInfoErrors
            }),
            numberSpecialHealthCareError () {
            	if (this.generalInfoErrors.number_allergies || this.generalInfoErrors.number_asthma 
            		|| this.generalInfoErrors.number_diabetes || this.generalInfoErrors.number_developmental_delays 
            		|| this.generalInfoErrors.number_social_emotional_needs || this.generalInfoErrors.number_seizures) {
            		return true
            	}
            	return false
            }
        },

        mounted () {
            this.$store.dispatch('cycle/setCycle', this.assessmentCycle)
            this.$store.dispatch('general_info/fetchGeneralInfo', {'assessment_cycle_id': this.cycle.id})
            this.$store.dispatch('general_info/fetchFacilityLicense', {
                'assessment_cycle_facility_id': this.cycle.facility_id
            })
        }
    }
</script>